<template>
  <div class="rule">
    <Search :renderData="renderData" :formData="form" @onSearch="onSearch" ></Search>
    <div class="fun-btn-box">
      <auth-button auth="member:point:rule:create">
        <el-button type="primary" class="fun-btn mr10" @click="onAdd" >添加积分规则</el-button>
      </auth-button>
    </div>
    <Table
      :loading="loading"
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #useRangeName="{ row }">{{ row.useRangeName }}</template>
      <template #range="{ row }">{{ row.range }}</template>
      <template #gainRuleName="{ row }">{{ row.gainRuleName ? row.gainRuleName : '---'}}</template>
      <template #days="{ row }">{{ row.days ? row.days + '天' : '---' }}</template>
      <template #deductionRuleName="{ row }">{{ row.deductionRuleName ? row.deductionRuleName : '---' }}</template>
      <template #deductionRatioName="{ row }">{{ row.deductionRatioName ? row.deductionRatioName : '---' }}</template>
      <template #dayDeductionLimitName="{ row }">{{ row.dayDeductionLimitName ? row.dayDeductionLimitName : '---' }}</template>
      <template #monthDeductionLimitName="{ row }">{{ row.monthDeductionLimitName ? row.monthDeductionLimitName : '---' }}</template>
      <template #deductionLimitName="{ row }">{{ row.deductionLimitName ? row.deductionLimitName : '---' }}</template>
      <template #disable="{ row }">{{ row.disable ? '禁用' : '启用' }}</template>
      <template #operation="{ scope }">
        <!-- <el-button type="text" @click="exportMemberByPortrait(scope.row)" >导出会员</el-button > -->
        <auth-button auth="member:point:rule:update">
          <el-button type="text" class="mr10" @click="edit(scope.row)">编辑</el-button>
        </auth-button>
        <auth-button v-if="scope.row.disable" auth="member:point:rule:update">
          <el-button type="text" class="error" @click="updateStatus(scope.row, false)">启用</el-button>
        </auth-button>
        <auth-button v-else auth="member:point:rule:update">
          <el-button type="text" class="error" @click="updateStatus(scope.row, true)">禁用</el-button>
        </auth-button>
      </template>
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import Search from "@/components/Search/index"
import Table from "@/components/Table/index"
import { api_getRuleList, api_putPointRuleSwitch, api_putPointRule} from '@/api/accumulationScore'
import tableList from '@/mixins/tableList'
export default {
  name: "mPortrait",
  mixins: [tableList],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    return {
      renderData: [
        {
          label: "范围类型",
          placeholder: "请选择范围类型",
          type: "select",
          multiple: false,
          key: "useRange",
          option: [{
            label: '商城',
            value: 'Mall'
          },{
            label: '业态',
            value: 'Category'
          },{
            label: '店铺',
            value: 'Store'
          }],
        },
        {
          label: "状态",
          placeholder: "请选择状态",
          type: "select",
          multiple: false,
          key: "disable",
          option: [
            { label: '启用', value: 'false' },
            { label: '禁用', value: 'true' }
          ],
        },
      ],
      form: {
        useRange: "",
        disable: "",
      },
      tableThData: [
        { prop: "useRangeName", label: "范围类型", minWidth: "120", },
        { prop: "range", label: "适用范围", minWidth: "260", },
        { prop: "disable", label: "状态", minWidth: "100", },
        { prop: "gainRuleName", label: "积分获取规则", minWidth: "130", },
        { prop: "days", label: "积分有效期", minWidth: "100", },
        { prop: "deductionRuleName", label: "积分抵扣规则", minWidth: "180", },
        { prop: "deductionRatioName", label: "积分抵扣比例", minWidth: "160", },
        { prop: "dayDeductionLimitName", label: "日抵扣上限", minWidth: "160", },
        { prop: "monthDeductionLimitName", label: "月抵扣上限", minWidth: "160", },
        { prop: "deductionLimitName", label: "单笔抵扣上限", minWidth: "160", },
        { prop: "operation", label: "操作", minWidth: "120", },
      ],
    };
  },
  created () {
  },
  methods: {
    onAdd () {
      this.$router.push({
        path: '/accumulationScore/rule/add'
      })
    },
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      const data = await api_getRuleList(params)
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },
    // 编辑
    edit (row) {
      this.$router.push({
        path: '/accumulationScore/rule/add?id=' + row.id
      })
    },
    // 删除
    updateStatus (row, status) {
      this.$baseConfirm(
        status ? '是否确认禁用该规则？' : '是否确认启用该规则？',
        {
          title: '提示',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          type: 'warning',
        },
        async () => {
          await api_putPointRuleSwitch({id: row.id})
          this.$baseMessage('操作成功', 'success')
          this.getList()
        }
      )
    }
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.rule {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  .fun-btn-box {
    margin-top: 20px;
  }
  .level-update, .integral-update{
    margin-top: 22px;
    ::v-deep{
      .el-radio__label{
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
      }
      .el-radio__input.is-checked + .el-radio__label{
        color: #05C8AF;
      }
      .el-form{
        margin-top: 33px;
        .el-form-item__label{
          color: #333;
          font-size: 16px;
        }
        .el-input{
          border-radius: 2px;
          font-size: 16px;
          .el-input__inner{
            background: #F2F3F5;
            border: 0;
          }
          .el-input__inner:focus{
            background: #fff;
            border: 1px solid #05C8AF;
          }
        }
        .el-input.is-focus{
          .el-input__inner{
            background: #fff;
          }
        }
        .tips{
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          line-height: 40px;
          margin-left: 20px
        }
      }
    }
    .button-div{
      overflow: hidden;
      float: right;
      margin-top: 33px;
      button{
        border: 0;
        width: 110px;
        height: 40px;
        border-radius: 2px;
        font-size: 16px;
      }
      .cancel{
        background: #F2F3F5;
        color: #666666;
      }
    }
  }
}
</style>
